import { dataReducer, DataReducerActions } from 'shared/reducers';

export const AdminNasOption = {
  vtr: 'VTR',
  tenant: 'Tenant',
};

export const adminNasReducerActions = {
  toggleAuthTenant: 'toggleAuthTenant',
  toggleIsVTR: 'toggleIsVTR',
  update: 'update',
  ...DataReducerActions,
};

function adminNasReducer(state, { action, payload }) {
  const { data, updatedData } = state;

  switch (action) {
    case adminNasReducerActions.toggleAuthTenant: {
      const { checked } = payload;
      const newState = {
        ...state,
        data: {
          ...data,
          option: checked ? AdminNasOption.tenant : '',
        },
      };

      if (checked) delete updatedData.vtr_nas_id;

      return newState;
    }
    case adminNasReducerActions.toggleIsVTR: {
      const { checked } = payload;
      const newState = {
        ...state,
        data: {
          ...data,
          option: checked ? AdminNasOption.vtr : '',
        },
      };

      if (checked) delete updatedData.tenant_secret;

      return newState;
    }
    case adminNasReducerActions.update: {
      // Payload is expected to be an object in this case.
      // E.G. dispatch({action:DataReducerActions.update, payload:{key: 'complexId', value: 20 }});
      const { key, value: newValue } = payload;
      const newData = { ...updatedData };

      if (newValue === data[key] || (newValue === '' && !data[key])) {
        delete newData[key];
      } else {
        newData[key] = newValue;
      }

      return { ...state, updatedData: newData, dirty: Object.keys(newData).length > 0 };
    }

    default:
      return dataReducer(state, { action, payload });
  }
}

export default adminNasReducer;
